
export default {
  selectMobileMenuList: { // 모바일메뉴 리스트
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/ignore/nrw/common/selectMobileMenu'
  },

  selectDashLrningList: { // 학습현황 학습중 리스트
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/mySpace/dashbrdLrning'
  },

  selectDashbrdCnt: { // 학습카운터
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/dashbrdCnt'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/dashBoard.js